// The backoffice design system's primitives (docs/ui-harmony-plan.md, C3).
// Pages are built from these; shadcn's button/input/select/switch/dialog
// under components/ui carry the same skin.
export { PageFrame, PageHeading, MetricsStrip, Metric, InfoPopover } from './PageFrame'
export type { MetricDef, MetricTone } from './PageFrame'
export { Module, ModuleStack, ModuleFooter } from './Module'
export { StatusPill, Tag, pillTone } from './StatusPill'
export type { PillTone } from './StatusPill'
export { Segmented } from './Segmented'
export type { Segment } from './Segmented'
export { Fields } from './Fields'
export type { FieldDef } from './Fields'
export { EmptyState, LoadingState } from './EmptyState'
export { NoticeProvider, useNotice, AttentionNote } from './Notice'
export { Progress } from './Progress'
export { Tabs } from './Tabs'
export type { TabDef } from './Tabs'
export { Toolbar, SearchInput } from './Toolbar'
